module.exports = __webpack_public_path__ + "img/our-focus-mobile.9b872ac5.png";